import React, { useState } from "react";
import "./DomainsSidebar.css";
import { Domain } from "../services/treatmentGoals";

interface DomainsSidebarProps {
  domains: Domain[];
  activeDomainId: number | null;
  onDomainSelect: (domainId: number) => void;
  onAddDomain: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

const DomainsSidebar: React.FC<DomainsSidebarProps> = ({
  domains,
  activeDomainId,
  onDomainSelect,
  onAddDomain,
  isCollapsed,
  onToggleCollapse,
}) => {
  return (
    <aside className={`domains-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="domains-sidebar__header">
        <h2 className="domains-sidebar__title">{!isCollapsed && "Domains"}</h2>
        <button
          className="domains-sidebar__toggle"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? "→" : "←"}
        </button>
      </div>

      {!isCollapsed && (
        <>
          <div className="domains-sidebar__content">
            {domains.map((domain) => (
              <button
                key={domain.id}
                className={`domain-item ${
                  activeDomainId === domain.id ? "active" : ""
                }`}
                onClick={() => onDomainSelect(domain.id)}
              >
                <span className="domain-item__name">{domain.name}</span>
                <span className="domain-item__count">
                  {domain.goals?.length || 0} goals
                </span>
              </button>
            ))}
          </div>
        </>
      )}
    </aside>
  );
};

export default DomainsSidebar;
